import gql from 'graphql-tag'

export default {
  duwaCodeItemFields: gql`
    fragment duwaCodeItemFields on DuwaCodeItem {
      code
      description
      parameters {
        name
        value
      }
    }
  `,

  duwaLocationItemFields: gql`
    fragment duwaLocationItemFields on DuwaLocationItem {
      location_name
      priority
      order
    }
  `
}
